"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _OrbitNetStyles = require("../../styles/OrbitNetStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var OrbitNetLabels = function OrbitNetLabels(_ref) {
  var rowIndex = _ref.rowIndex,
      labels = _ref.labels,
      type = _ref.type,
      textColor = _ref.textColor,
      _ref$opts = _ref.opts,
      opts = _ref$opts === void 0 ? {} : _ref$opts;

  var _useState = (0, _react.useState)(2),
      _useState2 = _slicedToArray(_useState, 2),
      getMaxShowLabel = _useState2[0],
      setMaxShowLabel = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      getShowTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var _useState5 = (0, _react.useState)('+2'),
      _useState6 = _slicedToArray(_useState5, 2),
      getMoreLabel = _useState6[0],
      setMoreLabel = _useState6[1];

  (0, _react.useEffect)(function () {
    switch (type) {
      case 'single':
        setMaxShowLabel(2);
        setShowTooltip(labels.length > 2);
        setMoreLabel("+".concat(labels.length - 2));
        break;

      case 'multiple':
        setMaxShowLabel(1);
        setShowTooltip(labels.length > 1);
        setMoreLabel("+".concat(labels.length - 1, " ").concat(opts.label ? opts.label : 'etiquetas'));
        break;

      default:
        setMaxShowLabel(2);
        setShowTooltip(labels.length > 2);
        setMoreLabel("+".concat(labels.length - 2));
    }
  }, [labels, type, opts]);
  return /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.Wrapper, {
    type: type
  }, !opts.singleTitle ? labels.map(function (label, key) {
    if (key >= getMaxShowLabel) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.WrapperLabel, {
      color: label.color,
      key: label.id,
      id: key
    }, label.description);
  }) : /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.SingleLabel, null, labels && labels.length > 0 && labels[0].description), getShowTooltip && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_OrbitNetStyles.MoreLabels, {
    textColor: textColor,
    "data-tip": true,
    "data-for": 'more-labels-'.concat(rowIndex)
  }, /*#__PURE__*/_react["default"].createElement("span", null, getMoreLabel)), /*#__PURE__*/_react["default"].createElement(_reactTooltip["default"], {
    id: 'more-labels-'.concat(rowIndex),
    "aria-haspopup": "true",
    place: "right"
  }, labels.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: label.id
    }, /*#__PURE__*/_react["default"].createElement("span", null, label.description), /*#__PURE__*/_react["default"].createElement("br", null));
  }))));
};

var _default = OrbitNetLabels;
exports["default"] = _default;